/**
 * Centralized tooltip texts for all components
 * To add a new tooltip:
 * 1. Add a new key-value pair to the tooltipTexts object
 * 2. Use the key in your component to reference the text
 */

const tooltipTexts = {
  // Chart headers tooltips
  trendAnalysis: "View analysis of driving challenges and trends across sessions",
  sessionParticipation: "Shows user participation status in training sessions",
  scoreDistribution: "Compare score distribution across different performance categories",
  driversRank: "Ranking of drivers based on their assessment scores",
  
  // Page headers tooltips
  dashboardHeader: "Overview of driver performance and assessment statistics",
  driverSegmentationHeader: "Categorization of drivers based on performance metrics",
  userWiseReportHeader: "Detailed analysis of individual driver assessments and progress",
  trendAnalysisHeader: "Analyze driving behavior patterns and improvement areas across sessions",
  driverScoreCategoryHeader: "Breakdown of driver scores across different assessment categories",
  userVehicleRemarksHeader: "Review and manage feedback on driver performance",
  violationTrendAnalysisHeader: "Detailed breakdown of driving violations ranked by frequency and impact",
  settingsHeader: "Manage user accounts, permissions, and system configuration",
  
  // Equipment permissions tooltips
  equipmentPermissionsSearch: "Search for specific employees or vehicles to view equipment permissions",
  
  // Add more tooltips as needed for other components
  // exampleKey: "Example tooltip text",
};

export default tooltipTexts; 